import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PlanSelection.css";

export default function PlanSelection() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [plan, setPlan] = useState("");
  const [hostCodes, setHostCodes] = useState([]);
  const [error, setError] = useState("");

  // Fetch host codes from public folder
  useEffect(() => {
    fetch("/hostCodes.json")
      .then(res => res.json())
      .then(data => setHostCodes(data))
      .catch(err => console.error("Error fetching host codes:", err));
  }, []);

  const handleContinue = () => {
    if (!name || !plan) {
      setError("Please enter name and select plan");
      return;
    }

    // Find an unused host code for selected plan
    const code = hostCodes.find(c => c.plan === plan && c.status === "Unused");
    if (!code) {
      setError("No available host codes for this plan. Contact Admin.");
      return;
    }

    // Save in session/local storage to use in HostAccess
    sessionStorage.setItem("hostName", name);
    sessionStorage.setItem("hostPlan", plan);
    sessionStorage.setItem("hostCode", code.code);

    navigate("/hostaccess");
  };

  return (
    <div className="plan-container">
      <h2>Select Plan & Enter Name</h2>
      <input
        type="text"
        placeholder="Enter your name"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <div className="plan-options">
        <label>
          <input
            type="radio"
            value="free"
            checked={plan === "free"}
            onChange={e => setPlan(e.target.value)}
          />
          Free (75 mins, 100 users)
        </label>
        <label>
          <input
            type="radio"
            value="paid"
            checked={plan === "paid"}
            onChange={e => setPlan(e.target.value)}
          />
          Paid (Unlimited)
        </label>
      </div>
      {error && <p className="error">{error}</p>}
      <button onClick={handleContinue}>Continue</button>
    </div>
  );
}
